import * as Three from 'three';
import { parseObject } from './object';

let i = 0;

export const parseRoof = (branch, context, options) => {
  const { _selfKey, parent } = options;
  const {
    positionX,
    positionZ,
    rotationX = 0,
    rotationY = 0,
    rotationZ = 0,
    angle = 0,
    color = 0x333333,
    previewOnly = false,
    materialA = 'roofing-round-rooftiles-1',
    materialB = 'roofing-round-rooftiles-1',
    materialC = 'brick-wall',
    isCorner,
    tilt = 0
  } = branch;

  if (!parent) {
    return;
  }

  if (tilt < 10 || tilt > 80) {
    return;
  }

  let instance = parent.getObjectByName(_selfKey);

  if (!instance) {
    instance = new Three.Group();

    const wallHeight = 25 - 10;
    const wallDepth = .5;
    const tiltRad = Three.MathUtils.degToRad(tilt);

    const wallSizeY = wallHeight * Math.cos(tiltRad) + 10;
    const fillInSizeX = 10 * Math.sin(tiltRad) + 2 * Math.sin(tiltRad * 2);

    if (!isCorner) {
      const sideA = parseObject({
        ...branch,
        sizeX: 10,
        sizeY: wallSizeY,
        sizeZ: wallDepth,
        positionX: 5,
        positionY: (wallSizeY / 2) * Math.cos(tiltRad) + .5,
        positionZ: -10 + 5 * Math.sin(tiltRad) + 4 * Math.sin(tiltRad * 2),
        color,
        primitive: 'wall',
        opacity: previewOnly ? 0.5 : 1.0,
        materialId: materialA,
        rotationX: -tiltRad,
        rotationY: 0,
        rotationZ: 0,
      }, context, {
        ...options,
        parent: instance,
        selectable: true,
        selectionTarget: false
      });
      sideA.name = 'sideA';

      const sideB = parseObject({
        ...branch,
        sizeX: 10,
        sizeY: wallSizeY,
        sizeZ: wallDepth,
        positionX: 5,
        positionY: (wallSizeY / 2) * Math.cos(tiltRad) + .5,
        positionZ: -10 + 5 * Math.sin(tiltRad) + 4 * Math.sin(tiltRad * 2) - .25,
        color,
        primitive: 'wall',
        opacity: previewOnly ? 0.5 : 1.0,
        materialId: materialB,
        rotationX: -tiltRad,
        rotationY: 0,
        rotationZ: 0,
      }, context, {
        ...options,
        parent: instance,
        selectable: true,
        selectionTarget: false
      });
      sideB.name = 'sideB';
    } else {
      const sideA = parseObject({
        ...branch,
        sizeX: fillInSizeX + Math.sin(tiltRad * 2) * 5.5,
        sizeY: wallSizeY,
        sizeZ: wallDepth,
        positionX: -(fillInSizeX / 2 + Math.sin(tiltRad * 2) * 2.75) + 9.9 + .13,
        positionY: (wallSizeY / 2) * Math.cos(tiltRad) + .5,
        positionZ: -10 + 5 * Math.sin(tiltRad) + 4 * Math.sin(tiltRad * 2),
        color,
        primitive: 'wall',
        opacity: previewOnly ? 0.5 : 1.0,
        materialId: materialA,
        holeX1: 0,
        holeY1: 1,
        holeX2: 1 - Math.sin(tiltRad) * .025,
        holeY2: 1,
        holeX3: .5 - Math.sin(tiltRad) * .015,
        holeY3: .5 + Math.sin(tiltRad) * .015,
        holeX4: 0,
        holeY4: 0 + Math.sin(tiltRad) * .025,
        rotationX: -tiltRad,
        rotationY: 0,
        rotationZ: 0,
      }, context, {
        ...options,
        parent: instance,
        selectable: true,
        selectionTarget: false
      });
      sideA.name = 'sideA';

      const sideB = parseObject({
        ...branch,
        sizeX: fillInSizeX + Math.sin(tiltRad * 2) * 5.5,
        sizeY: wallSizeY,
        sizeZ: wallDepth,
        positionX: -(fillInSizeX / 2 + Math.sin(tiltRad * 2) * 2.75) + 9.75 + (.125 * Math.sin(tiltRad)) + (.115 * Math.cos(tiltRad)) - (.15 * Math.sin(tiltRad * 2)),
        positionY: (wallSizeY / 2) * Math.cos(tiltRad) + .5,
        positionZ: -10 + 5 * Math.sin(tiltRad) + 4 * Math.sin(tiltRad * 2) - .25,
        color,
        primitive: 'wall',
        opacity: previewOnly ? 0.5 : 1.0,
        materialId: materialA,
        holeX1: 0 + Math.sin(tiltRad) * .025,
        holeY1: 1,
        holeX2: 1,
        holeY2: 1,
        holeX3: 1,
        holeY3: 0 + Math.sin(tiltRad) * .025,
        holeX4: .5 + Math.sin(tiltRad) * .015,
        holeY4: .5 + Math.sin(tiltRad) * .015,
        rotationX: -tiltRad,
        rotationY: 0,
        rotationZ: 0,
      }, context, {
        ...options,
        parent: instance,
        selectable: true,
        selectionTarget: false
      });
      sideB.name = 'sideA';

      sideB.rotateOnWorldAxis(new Three.Vector3(0, 1, 0), -Math.PI / 2);
    }

    const fillA = parseObject({
      ...branch,
      sizeX: fillInSizeX + Math.sin(tiltRad * 2) * 5.5,
      sizeY: wallSizeY * Math.cos(tiltRad),
      sizeZ: wallDepth,
      positionX: 9.5,
      positionY: (wallSizeY * Math.cos(tiltRad)) / 2,
      positionZ: -10 + fillInSizeX / 2 + Math.sin(tiltRad * 2) * 2.75,
      color,
      primitive: 'wall',
      opacity: previewOnly ? 0.5 : 1.0,
      materialId: materialC,
      holeX1: 0,
      holeY1: 1,
      holeX2: 1,
      holeY2: 1,
      holeX3: 0,
      holeY3: 0,
      holeX4: 0,
      holeY4: 0,
      rotationX: 0,
      rotationY: Math.PI / 2,
      rotationZ: 0,
    }, context, {
      ...options,
      parent: instance,
      selectable: true,
      selectionTarget: false
    });
    fillA.name = 'sideC';

    const fillB = parseObject({
      ...branch,
      sizeX: fillInSizeX + Math.sin(tiltRad * 2) * 5.5,
      sizeY: wallSizeY * Math.cos(tiltRad),
      sizeZ: wallDepth,
      positionX: isCorner ? -(fillInSizeX / 2 + Math.sin(tiltRad * 2) * 2.75) + 9.9 : .5,
      positionY: (wallSizeY * Math.cos(tiltRad)) / 2,
      positionZ: isCorner ? -9.5 : -10 + fillInSizeX / 2 + Math.sin(tiltRad * 2) * 2.75,
      color,
      primitive: 'wall',
      opacity: previewOnly ? 0.5 : 1.0,
      materialId: materialC,
      holeX1: 0,
      holeY1: 1,
      holeX2: 1,
      holeY2: 1,
      holeX3: 0,
      holeY3: 0,
      holeX4: 0,
      holeY4: 0,
      rotationX: 0,
      rotationY: isCorner ? 0 : Math.PI / 2,
      rotationZ: 0,
    }, context, {
      ...options,
      parent: instance,
      selectable: true,
      selectionTarget: false
    });
    fillB.name = 'sideC';

    instance.position.x = positionX;
    instance.position.y = 0;
    instance.position.z = positionZ;

    instance.rotation.x = 0;
    instance.rotation.y = 0;
    instance.rotation.z = 0;

    instance.rotateX(rotationX);
    if (!rotationY) {
      instance.rotateY(angle);
    }
    instance.rotateY(rotationY);
    instance.rotateZ(rotationZ);

    instance.selectable = true;
    instance.selectionTarget = true;
    parent.add(instance);

    const direction = instance.getWorldDirection().applyAxisAngle(new Three.Vector3(0, 1, 0), Math.PI / 2);

    branch.endX = Math.round(positionX + 10 * direction.x);
    branch.endZ = Math.round(positionZ + 10 * direction.z);
  }

  return instance;
};
